<template>

  <div class="flex flex-col justify-center py-12 sm:px-6 lg:px-8">

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <img class="w-auto h-20 mx-auto mt-1" src="@/assets/hp/kairo-logo-v2.png" alt="Kairo">
        <h2
          class="text-gray-700 font-medium text-center mb-6"
        >Can't log in?</h2>

        <div>
          <Form
            submit="return false"
            @submit="request"
            class="space-y-6"
          >
            <div v-if="msgError" class="rounded-md bg-red-50 p-4">
              <div class="flex">
                <div class="flex-shrink-0">
                  <!-- Heroicon name: x-circle -->
                  <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                  </svg>
                </div>
                <div class="ml-3">
                  <h3 class="text-sm font-medium text-red-800">
                    There was a problem!
                  </h3>
                  <div class="mt-2 text-sm text-red-700">
                    {{msgError}}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="msgSuccess" class="rounded-md bg-green-50 p-4">
              <div class="flex">
                <div class="flex-shrink-0">
                  <!-- Heroicon name: x-circle -->
                  <svg class="h-5 w-5 text-green-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd" />
                  </svg>
                </div>
                <div class="ml-3">
                  <h3 class="text-sm font-medium text-green-800">
                    We just sent you a verification link
                  </h3>
                  <div class="mt-2 text-sm text-green-700">
                    We just sent a verification link to your email. If you don't see our email in your inbox, check your spam folder.
                  </div>
                </div>
              </div>
            </div>

            <div>
              <label for="email" class="block text-sm font-medium text-gray-700">
                Email address
              </label>
              <div class="mt-1">
                <Field
                  id="email"
                  v-model="crendentials.email"
                  type="email"
                  name="email"
                  :rules="validateEmail"
                  placeholder="hey@email.com"
                  autocomplete="email"
                  class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
                <ErrorMessage name="email" class="mt-2 text-sm text-red-600" />
              </div>
            </div>

            <div>
              <button
                :disabled="lockButtons"
                class="disabled:opacity-50 w-full border-green-600 border-2 border-b-3 items-center p-2 pb-3 rounded-lg shadow-sm text-green-600 bg-green-200 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-50"
                style="box-shadow: inset 0px -6px 0px #34D399, inset 0 -7px 0 0 #ECFDF5, inset 0px 1px 0px 1px #ECFDF5;"
              >
                Send recovery link
              </button>
            </div>
          </Form>



        </div>

        <div class="mt-6">
          <div class="relative">
            <div class="absolute inset-0 flex items-center">
              <div class="w-full border-t border-gray-300"></div>
            </div>
            <div class="relative flex justify-center text-sm">
            <span class="px-2 bg-white text-gray-500">
            </span>
            </div>
          </div>
          <div>
            <div class="relative flex justify-center text-sm mt-4">
              <span class="px-2 bg-white text-gray-500">
                <router-link
                  to="/login"
                  class="font-medium text-indigo-600 hover:text-indigo-500"
                >Return to log in
                </router-link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <AppFooter />

</template>

<script>
  import { mapActions } from "vuex";
  import { Field, Form, ErrorMessage } from 'vee-validate';
  import AppFooter from "../components/AppFooter.vue";

  export default {
    name: "RecoverAccount",
    components: {
      Field,
      Form,
      ErrorMessage,
      AppFooter
    },
    data() {
      return {
        crendentials: {
          email: ""
        },
        lockButtons: false,
        msgError: null,
        msgSuccess: null
      };
    },
    methods: {
      ...mapActions("auth", ["requestPasswordRecover"]),
      request() {
        this.msgError = '';
        this.msgSuccess = '';
        this.lockButtons = true;
        this.requestPasswordRecover(this.crendentials.email)
            .then(() => {
              this.lockButtons = false;
              this.msgSuccess = true;
            })
            .catch(error => {
              let msgError = `${error}`;
              if (msgError.indexOf('User not found')) {
                msgError = 'User not found';
              }

              this.msgError = msgError;
              this.lockButtons = false;
            });
      },
      validateEmail(value) {
        if (!value) {
          return 'This field is required';
        }
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,10}$/i.test(value)) {
          return 'This field must be a valid email';
        }
        return true;
      },
    },
  };
</script>
